// extracted by mini-css-extract-plugin
export default {"hoverableCell":"styles_hoverableCell__UjJ5O","scalableIcon":"styles_scalableIcon__W7Max"};